module.exports = __webpack_public_path__ + "static/media/user-research-2.ac306b6d.png";